import { render, staticRenderFns } from "./ProductPropertyValue.vue?vue&type=template&id=448eb07c"
import script from "./ProductPropertyValue.vue?vue&type=script&lang=js"
export * from "./ProductPropertyValue.vue?vue&type=script&lang=js"
import style0 from "./ProductPropertyValue.vue?vue&type=style&index=0&id=448eb07c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports